import * as Factory from 'factory.ts'
import faker from 'faker'

import { EntityFactory } from '@webapp/core/utils/mocks/EntityFactory'
import {
  TravelDestination,
  type TravelDestinationConstructor,
} from './TravelDestination'
import { TravelTransportTypes } from '../enums/TravelTransportTypeEnum'
import { TravelAddressConstructorFactory } from '../TravelAddress'

export const TravelDestinationConstructorFactory =
  Factory.Sync.makeFactory<TravelDestinationConstructor>({
    id: Factory.each(() => faker.random.number()),
    sequence: Factory.each((i) => i),
    transport: TravelTransportTypes.FLIGHT,
    departurePlaceId: Factory.each(() => faker.random.uuid()),
    departureReference: Factory.each(() => faker.random.uuid()),
    departureDate: '2026-07-01T09:00:00Z',
    departureAddress: Factory.each(() =>
      TravelAddressConstructorFactory.build()
    ),
    arrivalPlaceId: Factory.each(() => faker.random.uuid()),
    arrivalReference: Factory.each(() => faker.random.uuid()),
    arrivalDate: '2026-07-01T17:00:00Z',
    arrivalAddress: Factory.each(() => TravelAddressConstructorFactory.build()),
  })

export const TravelDestinationFactory = EntityFactory(
  TravelDestination,
  TravelDestinationConstructorFactory
)
